import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { Role } from '@core/configs/roles.config';
import { AuthService, SaucerLogService } from '@core/services/apis';
import { Subscription } from 'rxjs';
import { LoginDialogComponent } from '../login-dialog/login-dialog.component';
import { ScreenName } from '@core/models/enums';
import { SidebarMenuModel } from '@core/models/interfaces';

@Component({
  selector: 'dbs-sidebar-menu',
  styleUrls: ['./sidebar-menu.component.scss'],
  templateUrl: './sidebar-menu.component.html',
})
export class SidebarMenuComponent implements OnInit, OnDestroy, OnChanges {
  @Input() isSdMenu = false;
  readonly role = Role;
  collapse = false;
  isClicked = true;
  isLoggedIn = false;
  subscriptions: Subscription[] = [];
  readonly defaultMenuItems: SidebarMenuModel[] = [
    {
      icon: 'business-management',
      link: 'business-management',
      title: '事業所管理',
      role: Role.roleCCJAdmin,
      screenName: ScreenName.businessManagement,
    },
    {
      icon: 'account-management',
      link: 'account-management',
      title: 'アカウント管理',
      role: Role.roleCCJAdmin,
      screenName: ScreenName.accountManagement,
    },
    {
      icon: 'notifications_v2',
      link: 'help',
      title: 'システムからのお知らせ',
      role: Role.roleCCJAdmin,
      screenName: ScreenName.help,
    },
    {
      icon: 'note_list',
      link: 'use-term-management',
      title: '利用規約管理',
      role: Role.roleCCJAdmin,
      screenName: ScreenName.useTermManagement,
    },
    {
      icon: 'admin_panel',
      link: 'admin-role',
      title: 'Admin・ロール管理',
      role: Role.roleCCJAdmin,
      children: [
        {
          icon: null,
          link: 'admin-role/ccj-admin',
          title: 'CCJ-Admin管理',
          role: Role.roleCCJAdmin,
          screenName: ScreenName.ccjAdmin,
        },
        {
          icon: null,
          link: 'admin-role/role-management',
          title: 'Live Consoleロール管理',
          role: Role.roleCCJAdmin,
          screenName: ScreenName.role,
        },
      ],
    },
    {
      icon: 'setting',
      link: 'settings-updates',
      title: 'システム管理',
      role: Role.roleCCJAdmin,
      screenName: ScreenName.settingsUpdates,
    },
  ];
  readonly sdMenuItems: SidebarMenuModel[] = [
    {
      icon: 'repair',
      link: 'login-notice',
      title: 'ログイン前のお知らせ',
      role: Role.rolePublic,
      screenName: ScreenName.loginNotice,
    },
    {
      icon: 'send_mail',
      link: 'send-mail',
      title: 'ユーザー向けメール送信',
      role: Role.rolePublic,
      screenName: ScreenName.notifications,
    },
  ];
  menuItems: SidebarMenuModel[] = this.defaultMenuItems;
  matchOptions: IsActiveMatchOptions = {
    paths: 'subset',
    fragment: 'ignored',
    matrixParams: 'ignored',
    queryParams: 'subset',
  };

  constructor(
    public dialog: MatDialog,
    public router: Router,
    private authService: AuthService,
    private saucerLogService: SaucerLogService,
  ) {
    // constructor
  }

  ngOnInit(): void {
    const getIsLoggedIn = this.authService.getIsLoggedIn().subscribe((res) => {
      this.isLoggedIn = res;
    });
    this.subscriptions.push(getIsLoggedIn);
  }

  ngOnChanges(changes: SimpleChanges) {
    // Check case URL prefix 'sd'
    if (changes?.isSdMenu?.currentValue) {
      this.menuItems = this.sdMenuItems;
    } else {
      this.menuItems = this.defaultMenuItems;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  toggleMenu() {
    this.collapse = !this.collapse;
    this.isClicked = !this.isClicked;
  }

  showLogin(routingUrl: string) {
    this.dialog
      .open(LoginDialogComponent, {
        panelClass: 'login-dialog',
        autoFocus: false,
      }).afterClosed().subscribe((res) => {
        if (res) {
          this.router.navigate([routingUrl]);
        }
      });
  }

  onMenuClick(item: SidebarMenuModel) {
    if (item.children && item.children.length && this.collapse) {
      this.toggleMenu();
      return;
    }

    // Write log change screen
    let currentMenu = this.menuItems.find(value => this.router.isActive(value.link, this.matchOptions));
    if (currentMenu?.children?.length) {
      const children = currentMenu.children.find(value => this.router.isActive(value.link, this.matchOptions));
      if (children) {
        currentMenu = children;
      }
    } else if (this.isSdMenu) {
      currentMenu = this.menuItems.find(value => this.router.isActive('sd/' + value.link, this.matchOptions));
    }

    const screenName = currentMenu?.screenName || '';
    const content = `${currentMenu.title}＞${item.title}`;
    this.saucerLogService.logChangeScreen(screenName, content);
  }
}
